import {Grid} from '@/components/ui/grid-atoms/GridAtoms.tsx'
import {AccessesDashboardTreatmentsCard} from '../accesses-dashboard-treatments-card/AccessesDashboardTreatmentsCard'
import {AccessesDashboardAbsencesCard} from '../accesses-dashboard-absences-card/AccessesDashboardAbsencesCard'
import {AccessesDashboardSingleAccessesCard} from '../accesses-dashboard-single-accesses-card/AccessesDashboardSingleAccessesCard'
import {AccessesDashboardNonInPersonAccessesCard} from '../accesses-dashboard-non-in-person-accesses-card/AccessesDashboardNonInPersonAccessesCard'
import {AccessesDashboardToValidateCard} from '../accesses-dashboard-to-validate-card/AccessesDashboardToValidateCard'

export const AccessesTableDashboard = () => {
    return (
        <Grid columns={5} gap={2}>
            <AccessesDashboardTreatmentsCard />
            <AccessesDashboardAbsencesCard />
            <AccessesDashboardSingleAccessesCard />
            <AccessesDashboardNonInPersonAccessesCard />
            <AccessesDashboardToValidateCard />
        </Grid>
    )
}
